import type { FocusedLeadContact, FocusedLeadContactPhone } from '../data';

export type OpenTextTarget = { contact: FocusedLeadContact | undefined; phone: FocusedLeadContactPhone };

export const numberOnlyPhone = (e164: string, standard = e164): FocusedLeadContactPhone => ({
	e164,
	standard,
	display: standard,
	isInternational: false,
});

/**
 * With `textedE164` the thread always opens on that number, even if the contact no longer lists it: conversations are
 * per number, so falling back to another phone would send the reply somewhere that never texted.
 */
export function resolveOpenTextTarget(
	contacts: readonly FocusedLeadContact[] | undefined,
	openTextContactId: string | undefined,
	textedE164?: string
): OpenTextTarget | undefined {
	if (!openTextContactId || !contacts) return undefined;
	const contact = contacts.find(c => c.id === openTextContactId);
	if (textedE164) {
		return { contact, phone: contact?.phones.find(p => p.e164 === textedE164) ?? numberOnlyPhone(textedE164) };
	}
	const phone = contact?.phones[0];
	return contact && phone ? { contact, phone } : undefined;
}
